import styled from "styled-components";

export const MessageChip = styled.div(({ theme }) => ({
    alignItems: 'center',
    color: 'rgba(29,165,255,.5)',
    display: 'flex',
    gap: '8px',
    float: 'right'
}));
